var map = {
	"./address.svg": "0e25",
	"./bulb.svg": "5a37",
	"./garbage.svg": "cee8",
	"./phone.svg": "dd82",
	"./radio.svg": "d8dc",
	"./radioButtonUnselect.svg": "db7d",
	"./search.svg": "8e8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";